var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumerology = function SvgNumerology(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A6FF",
    d: "M50 25.182c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M35.327 14.687a7.9 7.9 0 0 0-11.172 0l-.96.96-.959-.96a7.9 7.9 0 0 0-11.173 11.171l.96.96L23.196 37.99l11.171-11.17.96-.96a7.9 7.9 0 0 0 0-11.172z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m27.62 36.135 1.854 1.855 9.108-9.107.782-.782a6.44 6.44 0 0 0 0-9.108m-21.499 4.711a5.767 5.767 0 0 0 10.661 0"
  }))));
};
export default SvgNumerology;